module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"refreshing":"Updating...","Текущая комиссия:":"Current commission:","text_error":"Error while loading data"},"ru":{"refreshing":"Обновление...","text_error":"Ошибка получения данных"}}')
  delete Component.options._Ctor
}
